/**
 * Auto-generated from backend/shared/constants/aggregations.py.
 * DO NOT MODIFY BY HAND. Run: npm run generate:chart-aggregations
 */

export const CHART_AGGREGATIONS = [
  { value: "sum", label: "Sum", sqlFunction: "sum" },
  { value: "avg", label: "Avg", sqlFunction: "avg" },
  { value: "count", label: "Count", sqlFunction: "count" },
  { value: "count_distinct", label: "Count Distinct", sqlFunction: "count" },
  { value: "min", label: "Min", sqlFunction: "min" },
  { value: "max", label: "Max", sqlFunction: "max" },
  { value: "median", label: "Median", sqlFunction: "median" },
  { value: "stddev", label: "Std Dev", sqlFunction: "stddev" },
  { value: "p10", label: "P10", sqlFunction: "quantile_cont" },
  { value: "p25", label: "P25", sqlFunction: "quantile_cont" },
  { value: "p50", label: "P50", sqlFunction: "quantile_cont" },
  { value: "p75", label: "P75", sqlFunction: "quantile_cont" },
  { value: "p90", label: "P90", sqlFunction: "quantile_cont" },
  { value: "p95", label: "P95", sqlFunction: "quantile_cont" },
  { value: "p99", label: "P99", sqlFunction: "quantile_cont" },
] as const;

export type ChartAggregationType = typeof CHART_AGGREGATIONS[number]['value'];
export type AggregationType = 'none' | ChartAggregationType;

export const SQL_AGGREGATION_FUNCTIONS = ["sum", "avg", "count", "min", "max", "median", "stddev", "quantile_cont"] as const;

export const QUANTILE_AGGREGATIONS: Readonly<Record<string, number>> = {"p10": 0.1, "p25": 0.25, "p50": 0.5, "p75": 0.75, "p90": 0.9, "p95": 0.95, "p99": 0.99};
